export function list(list) {
  return {
    id: list.serverId,
    name: list.name,
    color: list.color,
    created: list.created,
    modified: list.modified,
  }
}

export function listItem(listItem) {
  return {
    id: listItem.serverId,
    listId: listItem.listId,
    name: listItem.name,
    status: listItem.status,
    note: listItem.note,
    priority: listItem.priority,
    tagIds: listItem.tagIds,
    created: listItem.created,
    modified: listItem.modified,
    reminderDate: listItem.reminderDate,
    reminderTime: listItem.reminderTime,
  }
}
